import * as z from 'zod'

export const voucherDto = z.object({
  _id: z.string().optional(),
  code: z.string(),
  outdated: z.boolean().optional(),
  expirationAt: z.string().nullable(),
  pointsRemaining: z.number().nullable().optional(),
})

export type Voucher = z.infer<typeof voucherDto>

/* Vouchers list */
export const voucherListDto = z.array(voucherDto)

/* Country config schema */
export const countryVoucherConfigSchema = z.object({
  startDate: z.string(),
  endDate: z.string(),
  stock: z.string(),
})

export type CountryVoucherConfig = z.infer<typeof countryVoucherConfigSchema>

/* Input Dto */
export type VoucherInput = {
  accessToken: string
  country: string
  nameId: string
  offerId?: string
}

export const CURRENT_STATUS_VIEW = {
  IS_REDEEMABLE: 'IS_REDEEMABLE',
  APPLIED_VOUCHER: 'APPLIED_VOUCHER',
  NO_POINTS: 'NO_POINTS',
  ERROR: 'ERROR',
} as const

export const CONFIG_MINECRAFT = {
  AR: {
    // requiredPoints: '150',
    stock: '248.781',
    startDate: '01/04/2025',
    endDate: '12/05/2025',
  },
  BR: {
    // requiredPoints: '3.000',
    stock: '495.000',
    startDate: '01/04/2025',
    endDate: '12/05/2025',
  },
  CO: {
    // requiredPoints: '400',
    stock: '31.965',
    startDate: '01/04/2025',
    endDate: '12/05/2025',
  },
  CR: {
    // requiredPoints: '60',
    stock: '106.041',
    startDate: '01/04/2025',
    endDate: '12/05/2025',
  },
  EC: {
    // requiredPoints: '1250',
    stock: '15.966',
    startDate: '03/04/2025',
    endDate: '14/05/2025',
  },
  UY: {
    // requiredPoints: '750',
    stock: '92.247',
    startDate: '02/04/2025',
    endDate: '13/05/2025',
  },
}

export const DEFAULT_COUNTRY_MINECRAFT = {
  // requiredPoints: 100,
  stock: '10000',
  startDate: '01/01/2025',
  endDate: '31/12/2025',
}

export const DEFAULT_COUNTRY_TICKETBOX = {
  stock: '5.001',
  startDate: '30/06/2025',
  endDate: '',
}

/* VoucherState Dto */
export const VoucherStateSchema = z.object({
  currentStatus: z.string(),
  code: z.string(),
  codeExpirationDate: z.string(),
  loyaltyPoints: z.number(),
  userPoints: z.number(),
  countryConfig: countryVoucherConfigSchema,
  vouchers: voucherListDto,
  errorMessage: z.string(),
  statusCodeError: z.number(),
  isLoading: z.boolean(),
  isLoadingPoints: z.boolean(),
})

export type VoucherState = z.infer<typeof VoucherStateSchema>

/* Landing names */

export const LandingNames = {
  MINECRAFT: 'minecraft',
  TICKETBOX: 'ticketbox',
} as const

export type LandingName = (typeof LandingNames)[keyof typeof LandingNames]

export const landingNameList = Object.values(LandingNames) as [LandingName, ...LandingName[]]
